import { getRecipient } from "src/api/contractSweepRecipientSetting";
import PageConfigProvider from "src/features/PageConfigProvider";
import ViewFilterTable from "./ViewFilterTable";
import { initFields } from "./types/FilterFields";
import useGetListParams from "./hooks/useGetListParams";

const ContractSweepRecipient = () => {
  const { getListParams } = useGetListParams();
  return (
    <PageConfigProvider
      translatePrefix="contractSweepRecipientSetting"
      initFields={initFields}
      getTableDataApiFunc={getRecipient}
      getListParams={getListParams}>
      <ViewFilterTable />
    </PageConfigProvider>
  );
};

export default ContractSweepRecipient;
